import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-unknown-payment-claim',
  templateUrl: './unknown-payment-claim.component.html',
  styleUrls: ['./unknown-payment-claim.component.scss']
})
export class UnknownPaymentClaimComponent implements AfterViewInit {

  public transaction: any = {};
  public data: any = {}
  public searchData: any = [];
  public active_player_ids: any = [];
  public company_uuid: any;
  @ViewChild('f') f : NgForm

  constructor(private http: HttpService, private route: ActivatedRoute) {
    this.company_uuid = this.http.getStaticSelectedCompany();
    const transaction_id: Observable<string> = this.route.params.pipe(map(p => p['transaction_id']));
    
    transaction_id.subscribe(tid => {
      if(tid) {
        this.getDetail(this.company_uuid, tid);
      } else {
        this.http.navigate(['/lo', this.company_uuid, 'unknown-payment'])
      }
    }) 
  }

  async getDetail(company_uuid, transaction_id) {
    this.transaction = await this.http.post('/admin/unknow-payment/get/detail', {company_uuid: company_uuid, transaction_id: transaction_id});

    if (!this.transaction['status']){
      this.http.navigate(['/lo', company_uuid, 'unknown-payment']);
    }

  }

  ngAfterViewInit(): void {
  }

  async search() {

    if (!this.data.code && !this.data.mobile && !this.data.name) {
      this.http.notify("You have to enter at least one field");
      return;
    }

    this.searchData = await this.http.post('/admin/player/get', this.data);

    this.f.resetForm();
  }

  async selectPlayer(player) {
    this.transaction.player_id = player.id;
    this.transaction.player_code = player.code;
    this.transaction.player_name = player.name;
    this.transaction.player_mobile = player.mobile;
    this.transaction.player_uuid = player.uuid;
    this.transaction.player_game_id = "";
    this.active_player_ids = await this.http.post("/admin/player/id/get", {player_uuid: player.uuid, status: 1});
  }

  async claim() {
    const s = await this.http.post("/admin/unknow-payment/claim", this.transaction);
    if (s) {
      this.http.navigate(['/lo', this.company_uuid, 'unknown-payment']);
    }
  }

  reset() {
    this.f.resetForm();
  }
}
